/**
 * Server-safe column ids + table display defaults for DEFAULT_USER_DISPLAY_PREFERENCES.
 * Keep in sync with ./columns.tsx.
 */

export const teacher_status_column_display_seeds: {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
}[] = [
    {
        id: "shortName",
        defaultDisplayPreferences: {
order: 1, size: 120, visible: true, displayAs: "string", pinned: true
        },
    },
    {
        id: "name",
        defaultDisplayPreferences: {
order: 2, size: 220, visible: true, displayAs: "string", pinned: false
        },
    },
    {
        id: "description",
        defaultDisplayPreferences: {
order: 3, size: 320, visible: true, displayAs: "string", pinned: false
        },
    },
    {
        id: "teachersCount",
        defaultDisplayPreferences: {
order: 4, size: 140, visible: true, displayAs: "number", pinned: false
        },
    },
];
